import { ToasterMode } from '@creditsights/styleguide-web';
import { useGlobalModalContext } from '../../components/GlobalModal';
import { ApiError } from '../../services/api-error.model';
import { useToast } from './useToast';
import { GENERIC_ERROR_TEXT } from '../../Base.constants';

interface UseMutationErrorToastResult {
  showErrorToast: (error: ApiError) => void;
}

const useMutationErrorToast = (): UseMutationErrorToastResult => {
  const { showToast } = useToast();
  const {
    store: { type },
  } = useGlobalModalContext();

  const isModalOpen = !!type;

  return {
    showErrorToast: (error: ApiError) => {
      const errorStatusCode = error?.response?.status ?? 0;
      if (errorStatusCode >= 400 && !isModalOpen) {
        showToast(GENERIC_ERROR_TEXT, ToasterMode.ERROR);
      }
    },
  };
};

export default useMutationErrorToast;
